import React, { useEffect, useRef, useState } from 'react';
import { CalendarIcon, CheckIcon, ChevronDownIcon } from 'lucide-react';
import { Period } from '../types/commission';
interface PeriodSelectProps {
  periods: Period[];
  selectedId: string;
  onSelect: (periodId: string) => void;
}
export function PeriodSelect({
  periods,
  selectedId,
  onSelect
}: PeriodSelectProps) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const selected = periods.find(period => period.id === selectedId) ?? periods[0];
  useEffect(() => {
    if (!open) return;
    function handlePointerDown(event: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);
  return <div ref={containerRef} className="relative" data-id="element-61" data-mp="mehvgrefeenm">
      <button type="button" aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen(value => !value)} className="inline-flex w-52 items-center gap-2 rounded-lg border border-slate-300 bg-white px-3.5 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50" data-id="element-62" data-mp="hiaxbks9u7g8">
        <CalendarIcon className="h-4 w-4 shrink-0 text-slate-500" aria-hidden="true" data-id="element-63" data-mp="156kf8bmd6b23" />
        <span className="flex-1 text-left" data-id="element-64" data-mp="1077ubwf1ze25">{selected.label}</span>
        <ChevronDownIcon className={`h-4 w-4 shrink-0 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-65" data-mp="109tzxqidvjhq" />
      </button>

      {open ? <ul role="listbox" aria-label="Select commission period" className="absolute right-0 z-20 mt-2 w-64 overflow-hidden rounded-lg border border-slate-200 bg-white py-1 shadow-lg" data-id="element-66" data-mp="3kyrisrlkv5jm">
          {periods.map(period => {
        const isSelected = period.id === selected.id;
        return <li key={period.id} role="option" aria-selected={isSelected} data-id="element-67" data-mp="2c1b74jtvi1p7">
                <button type="button" onClick={() => {
            onSelect(period.id);
            setOpen(false);
          }} className={`flex w-full items-center justify-between gap-3 px-3.5 py-2.5 text-left text-sm transition hover:bg-slate-50 ${isSelected ? 'font-semibold text-brand-800' : 'text-slate-700'}`} data-id="element-68" data-mp="1y1ikazlgw5mi">
                  <span data-id="element-69" data-mp="1t2fehcxnxvdh">
                    {period.label}
                    <span className="ml-2 text-xs font-medium text-slate-400" data-id="element-70" data-mp="1t40a75vprkcx">
                      {period.isCurrent ? 'In progress' : 'Closed'}
                    </span>
                  </span>
                  {isSelected ? <CheckIcon className="h-4 w-4 shrink-0 text-brand-700" aria-hidden="true" data-id="element-71" data-mp="15cl02qxp3yr4" /> : null}
                </button>
              </li>;
      })}
        </ul> : null}
    </div>;
}